import React, { useState, useEffect } from "react";
import axios from "axios";
import CustomAlert from "../CustomAlert";
import Pagination from "../section/Pagination";
import { Trash, TrashWhite } from "../../assets/icons/icons";

const Users = () => {
  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [alert, setAlert] = useState({ show: false, type: "", message: "" });
  // Dialog states for deletion
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const [showBulkDeleteDialog, setShowBulkDeleteDialog] = useState(false);

  // تأكد من ضبط رابط الـ API حسب بيئتك
  const API_BASE = "https://laravel-api.aj-mart.com/api";
  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    if (token) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }
  }, []);
  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      // نفترض أن الـ API تُرجع بيانات المستخدمين بالشكل { status: true, data: [ ... ] }
      const response = await axios.get(`${API_BASE}/users`);
      if (response.data.status === true) {
        setUsers(response.data.data);
      } else {
        showAlertMessage("error", " erorr when fetching   ");
      }
    } catch (error) {
      console.error("Error fetching users:", error);
      showAlertMessage("error", "erorr when fetching     ");
    } finally {
      setLoading(false);
    }
  };

  const showAlertMessage = (type, message) => {
    setAlert({ show: true, type, message });
    setTimeout(() => setAlert({ show: false, type: "", message: "" }), 5000);
  };

  // التعامل مع تحديد الصفوف
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedUsers(users.map((user) => user.id));
    } else {
      setSelectedUsers([]);
    }
  };

  const handleSelectUser = (id) => {
    if (selectedUsers.includes(id)) {
      setSelectedUsers(selectedUsers.filter((uid) => uid !== id));
    } else {
      setSelectedUsers([...selectedUsers, id]);
    }
  };

  // حذف فردي: عرض Dialog تأكيد ثم الحذف
  const handleDeleteClick = (id) => {
    setUserToDelete(id);
    setShowDeleteDialog(true);
  };

  const confirmDelete = async () => {
    try {
      await axios.delete(`${API_BASE}/users/${userToDelete}`);
      setUsers(users.filter((user) => user.id !== userToDelete));
      showAlertMessage("success", "deleting success");
    } catch (error) {
      console.error("Error deleting user:", error);
      showAlertMessage("error", " erorr to delete");
    } finally {
      setShowDeleteDialog(false);
      setUserToDelete(null);
    }
  };

  // حذف جماعي: عند اختيار أكثر من مستخدم
  const handleBulkDelete = () => {
    if (selectedUsers.length === 0) {
      showAlertMessage("error"," chose users to deleted");
      return;
    }
    setShowBulkDeleteDialog(true);
  };

  const confirmBulkDelete = async () => {
    try {
      await Promise.all(
        selectedUsers.map((id) =>
          axios.delete(`${API_BASE}/users/${id}`)
        )
      );
      setUsers(users.filter((user) => !selectedUsers.includes(user.id)));
      showAlertMessage("success", "delete users success");
      setSelectedUsers([]);
    } catch (error) {
      console.error("Error bulk deleting users:", error);
      showAlertMessage("error", " erorr to delete users selected  ");
    } finally {
      setShowBulkDeleteDialog(false);
    }
  };

  if (loading) return <div className="py-[25px]">loading users</div>;

  return (
    <section className="py-[25px]">
      <div className="main-title mb-[20px]">All Clients</div>
      {alert.show && (
        <CustomAlert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert({ show: false, type: "", message: "" })}
        />
      )}
      <div className="flex justify-end items-center gap-[10px] mb-[20px]">
        <button
          className={`btn bg-red-500 hover:bg-red-600 flex items-center gap-2 ${
            selectedUsers.length === 0 ? "opacity-50 cursor-not-allowed" : ""
          }`}
          onClick={handleBulkDelete}
          disabled={selectedUsers.length === 0}
        >
          <TrashWhite />
          <span>select delete({selectedUsers.length})</span>
        </button>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse border border-gray-200 text-left">
          <thead className="bg-gray-100">
            <tr>
              <th className="border border-gray-200 p-2">
                <input
                  type="checkbox"
                  onChange={handleSelectAll}
                  checked={selectedUsers.length === users.length}
                />
              </th>
              <th className="border border-gray-200 p-2">Client Name</th>
              <th className="border border-gray-200 p-2">Phone Number</th>
              <th className="border border-gray-200 p-2">Town/City</th>
              <th className="border border-gray-200 p-2">Email Address</th>
              <th className="border border-gray-200 p-2">Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user.id} className="bg-white hover:bg-gray-50">
                <td className="border border-gray-200 p-2">
                  <input
                    type="checkbox"
                    checked={selectedUsers.includes(user.id)}
                    onChange={() => handleSelectUser(user.id)}
                  />
                </td>
                <td className="border border-gray-200 p-2">{user.user_name}</td>
                <td className="border border-gray-200 p-2">{user.user_phone_num}</td>
                <td className="border border-gray-200 p-2">{user.user_city}</td>
                <td className="border border-gray-200 p-2">{user.user_email}</td>
                <td className="border border-gray-200 p-2">
                  <button
                    className="text-red-600 hover:text-red-800"
                    onClick={() => handleDeleteClick(user.id)}
                  >
                    <Trash />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="py-[25px]">
        <Pagination />
      </div>

      {/* Dialog تأكيد الحذف الفردي */}
      {showDeleteDialog && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white w-[400px] rounded-lg shadow-lg p-5 text-center">
            <h2 className="text-xl font-bold mb-4"> </h2>
            <p className="mb-4">Are you sure you want to delete this users?</p>
            <div className="flex justify-center gap-4">
              <button
                className="btn bg-gray-300 hover:bg-gray-400"
                onClick={() => setShowDeleteDialog(false)}
              >
                no
              </button>
              <button className="btn bg-red-500 hover:bg-red-600" onClick={confirmDelete}>
                Yes
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Dialog تأكيد الحذف الجماعي */}
      {showBulkDeleteDialog && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white w-[400px] rounded-lg shadow-lg p-5 text-center">
            <h2 className="text-xl font-bold mb-4">Are you sure you want to delete this users?  </h2>
            <p className="mb-4">
            Are you sure you want to delete this {selectedUsers.length}  users?
            </p>
            <div className="flex justify-center gap-4">
              <button
                className="btn bg-gray-300 hover:bg-gray-400"
                onClick={() => setShowBulkDeleteDialog(false)}
              >
                                  Cancel
              </button>
              <button className="btn bg-red-500 hover:bg-red-600" onClick={confirmBulkDelete}>
              Confirm Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Users;
